import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {CustomScrollingService} from '../../../services/custom-scrolling.service';
import {isPlatformBrowser} from '@angular/common';
// @ts-ignore
import {HtmlElementService} from '../../../services/html-element.service';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StickyHeaderService {
  headerElement: HTMLElement;
  headerTopValue = new BehaviorSubject(0);
  readonly resizeCallback: () => void;

  constructor(
    private customScrollingService: CustomScrollingService,
    @Inject(PLATFORM_ID) public platformId: object,
    private htmlElementService: HtmlElementService
  ) {
    this.resizeCallback = this.getResizeCallback();
  }

  public enableStickyOffset(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('resize', this.resizeCallback, {passive: true});
      window.addEventListener('scroll', this.resizeCallback, {passive: true});
      this.calcStickyHeaderTopStyle();
    }
  }

  public disableStickyOffset(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('resize', this.resizeCallback);
      window.removeEventListener('scroll', this.resizeCallback);
      this.setHeaderTopStyle(0);
    }
  }

  /**
   * Calculates and sets the css attribute 'top'.
   * On the product page, the global header should be relative and the page header should be sticky.
   */
  calcStickyHeaderTopStyle(): void {
    if (isPlatformBrowser(this.platformId)) {
      const headerHeight: number = this.customScrollingService.calculateElementHeight('cx-page-layout.header');
      const height: number = Math.min(Math.abs(headerHeight), this.htmlElementService.documentOffset());
      this.headerTopValue.next(height);
      this.setHeaderTopStyle(-height);
    }
  }

  setHeaderTopStyle(top: number) {
    if (!this.headerElement) {
      this.headerElement = document.querySelector('header');
    }
    const topVal: string = top + 'px';
    if (this.headerElement && this.headerElement.style && this.headerElement.style.top !== topVal) {
      this.headerElement.style.top = topVal;
    }
  }

  /**
   * Function to execute on a resize event.
   */
  getResizeCallback(): () => void {
    const self: StickyHeaderService = this;
    return () => {
      self.calcStickyHeaderTopStyle();
    };
  }
}
